<template>
  <div
    class="logo-container"
    :style="[containerStyle, positionStyle]"
    @click="$emit('click')"
  >
    <img
      ref="imgEl"
      class="logo-image"
      :src="src"
      :style="imageStyle"
      @load="handleImageLoad"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  src: String,
  // logo的位置
  position: {
    type: String,
    default: "center",
    validator: value =>
      [
        "top-left",
        "top-center",
        "top-right",
        "center-left",
        "center",
        "center-right",
        "bottom-left",
        "bottom",
        "bottom-right"
      ].includes(value)
  },
  // 横版配置
  horizontal: {
    type: Object,
    default: () => ({
      container: { width: "150px", height: "56px" },
      image: { maxWidth: "150px", maxHeight: "56px" }
    })
  },
  // 竖版配置
  vertical: {
    type: Object,
    default: () => ({
      container: { height: "80px" },
      image: { maxHeight: "80px" }
    })
  },
  // 宽高比阈值（默认为1:1）
  aspectRatioThreshold: {
    type: Number,
    default: 1
  }
});

const positionMap = {
  "top-left": ["flex-start", "flex-start"],
  "top-center": ["center", "flex-start"],
  "top-right": ["flex-end", "flex-start"],
  "center-left": ["flex-start", "center"],
  center: ["center", "center"],
  "center-right": ["flex-end", "center"],
  "bottom-left": ["flex-start", "flex-end"],
  bottom: ["center", "flex-end"],
  "bottom-right": ["flex-end", "flex-end"]
};

const positionStyle = computed(() => {
  const [mainAxis, crossAxis] = positionMap[props.position];
  return {
    display: "flex",
    justifyContent: mainAxis,
    alignItems: crossAxis
  };
});

const emit = defineEmits(["type-change", "click"]);

const imgEl = ref(null);
const logoType = ref("horizontal");

const handleImageLoad = () => {
  const { naturalWidth, naturalHeight } = imgEl.value;
  const aspectRatio = naturalWidth / naturalHeight;

  const newType =
    aspectRatio > props.aspectRatioThreshold ? "horizontal" : "vertical";

  if (newType !== logoType.value) {
    logoType.value = newType;
    emit("type-change", newType);
  }
};

const containerStyle = computed(() => ({
  ...props[logoType.value].container
}));

const imageStyle = computed(() => ({
  objectFit: "contain",
  ...props[logoType.value].image
}));
</script>

<style scoped>
.logo-container {
  position: relative;
}
</style>
